module.exports = __webpack_public_path__ + "img/ewm2.c5e0cdb8.png";